<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="BannerCode：" prop="code">
                    <el-input v-model.trim="form.code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="Banner名称：" prop="name">
                    <el-input v-model.trim="form.name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="区域：" prop="region">
                    <el-select v-model="form.region" :disabled="edit">
                        <el-option label="中国" value="cn"> </el-option>
                        <el-option label="欧洲" value="eu"> </el-option>
                        <el-option label="美洲" value="us"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select v-model="form.status" :disabled="edit">
                        <el-option label="下架" :value="1"> </el-option>
                        <el-option label="测试" :value="2"> </el-option>
                        <el-option label="上架" :value="3"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-right: 16px;">
                <el-button type="primary" size="small" @click="addBanner">新建</el-button>
            </div>
        </div>
        <el-table :data="tableList" size="mini">
            <el-table-column label="BannerCode">
                <template v-slot="scope">
                    <span>{{ scope.row.code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Banner名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="跳转地址">
                <template v-slot="scope">
                    <span>{{ scope.row.click_url }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区域" width="70px">
                <template v-slot="scope">
                    <span>{{ scope.row.region === 'cn' ? '中国' : scope.row.region === 'us' ? '美洲' : scope.row.region ===
                        'eu' ? '欧洲' : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="开始时间(+8)" width="180px" prop="begin_time" :formatter="(row) => row.begin_time && dayjs.unix(row.begin_time).format('YYYY-MM-DD HH:mm:ss')
                ">
            </el-table-column>
            <el-table-column label="结束时间(+8)" width="180px" prop="end_time" :formatter="(row) => row.end_time && dayjs.unix(row.end_time).format('YYYY-MM-DD HH:mm:ss')
                ">
            </el-table-column>
            <el-table-column label="状态" width="120px">
                <template v-slot="scope">
                    <el-select v-model="scope.row.status" placeholder="" size="mini"
                        @focus="scope.row._oldStatus = scope.row.status"
                        @change="(val) => updateStstus(scope.row, val)">
                        <el-option label="下架" :value="1" />
                        <el-option label="测试" :value="2" />
                        <el-option label="上架" :value="3" />
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="规则">
                <template v-slot="scope">
                    <el-select v-model="scope.row.rule_code" placeholder="" size="mini"
                        @change="(val) => updateRule(scope.row, val)" :disabled="scope.row.status !== 1">
                        <el-option v-for="(item) in ruleList" :key="item.code" :label="item.name" :value="item.code" />
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="发布人数" width="90px">
                <template v-slot="scope">
                    <span>{{ scope.row.count }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260px">
                <template v-slot="scope">
                    <router-link :to="'/iot/content/banneradd/' + scope.row.code">
                        <el-button type="info" size="mini" class="btnClass"
                            :disabled="scope.row.status !== 1">编辑</el-button>
                    </router-link>
                    <el-button type="danger" size="mini" style="margin-left: 10px;"
                        @click="deleteBanner(scope.row)">删除</el-button>
                    <el-button type="primary" size="mini" style="margin-left: 10px;"
                        @click="previewCount(scope.row)">人数预览</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            code: '',
            name: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const tableList = ref([])
        const ruleList = ref([])

        // 获取规则列表
        const getContentManageRuleList = async () => {
            const res = await api.ContentManageRuleList({ page: 1, limit: 500 })
            if (res.data.code === 200) {
                const { list } = res.data.data
                ruleList.value = list
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.ContentManageBannerList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { list, page_info } = res.data.data
                tableList.value = list
                pagination.total = page_info.total
                pagination.page = page_info.current_page
                // 遍历list, 调用api.ContentManageRuleCount, 给每一行添加count字段, 结果赋值给count
                list.forEach(async (item, idx) => {
                    try {
                        const resCount = await api.ContentManageRuleCount({ code: item.code, region: item.region })
                        if (resCount.data.code === 200) {
                            // 直接更新tableList中的对应项
                            tableList.value[idx].count = resCount.data.data.count
                        } else {
                            ElMessage.error('人数查询失败: ' + resCount.msg)
                        }
                    } catch (e) {
                        ElMessage.error('人数查询异常')
                    }
                })
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const addBanner = () => {
            router.push('/iot/content/banneradd/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        // 更新状态
        const updateStstus = async (row, status) => {
            const res = await api.ContentManageBannerUpdateStatus({ code: row.code, status, region: row.region })
            if (res.data.code == 200) {
                ElMessage.success('更新成功')
                onSearch()
            } else {
                ElMessage.error('更新失败' + res.data.msg)
                row.status = row._oldStatus
            }
        }

        // 更新规则
        const updateRule = async (row, rule_code) => {
            const res = await api.ContentManageBannerUpdateRule({ code: row.code, rule_code })
            if (res.data.code == 200) {
                ElMessage.success('更新成功')
                onSearch()
            } else {
                ElMessage.error('更新失败' + res.data.msg)
            }
        }

        // 删除
        const deleteBanner = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.ContentManageBannerDelete({ code: row.code })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        const previewCount = async (row) => {
            const res = await api.ContentManageRulePreviewCount({ code: row.code, region: row.region, rule_type: 1 })
            if (res.data.code === 200) {
                ElMessageBox.alert(`${res.data.data.count} 人`, '人数预览', {
                    confirmButtonText: 'OK'
                })
            } else {
                ElMessage.error('人数预览失败: ' + res.data.msg)
            }
        }

        onMounted(() => {
            getContentManageRuleList()
            onSearch()
        })

        return {
            form,
            onSearch,
            tableList,
            formRef,
            pagination,
            handleCurrentChange,
            addBanner,
            resetForm,
            deleteBanner,
            util,
            getContentManageRuleList,
            ruleList,
            dayjs,
            updateStstus,
            updateRule,
            previewCount
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
